import { FC } from 'react';

export type AlignCenterIconProps = {};

export const AlignCenterIcon: FC<AlignCenterIconProps> = ({}) => (
  <svg fill="none" height="10" viewBox="0 0 14 10" width="14" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M10.6665 3.33329H2.6665M12.6665 0.666626H0.666504M12.6665 5.99996H0.666504M10.6665 8.66663H2.6665"
      stroke="#475467"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="1.33333"
    />
  </svg>
);
